import BaseService from './BaseService.js';

class PartnerService extends BaseService {
  get(tab, filters, pagination) {
    return this.apiGet({
      url: '/tazama/partner',
      params: {
        filters,
        page: filters.page,
        perPage: filters.pageSize,
      },
    });
  }

  create(data) {
    return this.apiPost({
      url: '/tazama/partner',
      data,
    });
  }

  accept(id) {
    return this.apiPut({ url: `/tazama/partner/approve/${id}` });
  }

  activate(id) {
    return this.apiPut({ url: `/tazama/partner/activate/${id}` });
  }

  decline(id) {
    return this.apiPut({ url: `/tazama/partner/decline/${id}` });
  }

  suspend(id) {
    return this.apiPut({ url: `/tazama/partner/suspend/${id}` });
  }

  block(id) {
    return this.apiPut({ url: `/tazama/partner/block/${id}` });
  }

  resendInvite(id) {
    return this.apiPut({ url: `/tazama/partner/resendInvite/${id}` });
  }

  update(id, data) {
    return this.apiPut({
      url: `/tazama/partner/${id}`,
      data,
    });
  }
}

export default new PartnerService();
